import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * True when the viewport is at or below the court-sheet two-pane breakpoint
 * (≤720px), i.e. the single-column mobile booking layout is active: the cart is
 * an ultra-minimal fixed bottom bar + an opt-in detail sheet, not the static
 * right-rail "YOUR CART" panel.
 *
 * MUI's `useMediaQuery` owns live resize subscription and server-safe fallback.
 * The 720px threshold is the booking cart's presentation contract: at and below
 * it the MUI bottom bar + Drawer replace the desktop cart rail. It is independent
 * of deleted legacy CSS and intentionally local to this module.
 */
const NARROW_QUERY = "(max-width: 720px)";

export function useIsNarrow(): boolean {
  return useMediaQuery(NARROW_QUERY, { noSsr: true });
}
